import React, { useState, useEffect } from 'react';
import { showErrorAlert } from '../../../../utils/alerts';
import { getEventIntrusionDetailsByBuildingId } from '../../../../utils/services/eventService';
import EventIntrusionList from './EventIntrusionList';
import PropTypes from 'prop-types';

const EventIntrusionsMonitor = ({ match }) => {
  const [eventIntrusions, setEventIntrusions] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const buildingId = match?.params?.buildingId;

  const getEventIntrusions = async () => {
    try {
      const response = await getEventIntrusionDetailsByBuildingId(buildingId, {
        page,
        limit: 10,
      });

      setEventIntrusions(response?.eventIntrusionDetails || []);
      setTotalPages(response?.totalPages || 1);
    } catch (error) {
      console.error('Error al obtener eventos', error);
      showErrorAlert('Error', error.message || 'No se pudieron obtener los eventos.');
    }
  };

  useEffect(() => {
    getEventIntrusions();
  }, [buildingId, page]);

  return (
    <div>
      <div className="mb-3 d-flex justify-content-between align-items-center">
        <h2 className="mb-0">Monitoreo de Intrusos</h2>

        <button type="button" className="btn d-flex align-items-center" onClick={getEventIntrusions}>
          <span className="material-icons">refresh</span>
          <span className="ms-2">Refrescar</span>
        </button>
      </div>

      <EventIntrusionList eventIntrusions={eventIntrusions} />

      <div className="mt-3 d-flex justify-content-between align-items-center">
        <button
          className="btn btn-secondary"
          onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
          disabled={page <= 1}
        >
          Anterior
        </button>
        <span>
          Página {page} de {totalPages}
        </span>
        <button
          className="btn btn-secondary"
          onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
          disabled={page >= totalPages}
        >
          Siguiente
        </button>
      </div>
    </div>
  );
};

EventIntrusionsMonitor.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      buildingId: PropTypes.string,
    }),
  }),
};

export default EventIntrusionsMonitor;
